import { FC } from 'react';
import styled from 'styled-components';

const BoxElement = styled.div<BoxProps>`
  display: ${props => (props.stackItems ? 'block' : 'flex')};
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  ${props => props.stackItems && props.horizontalPositioning === 'center' && 'text-align: center;'}
  ${props =>
    !props.stackItems &&
    props.horizontalPositioning &&
    `justify-content: ${transformFlexEndCSSValue(props.horizontalPositioning)};`}
  ${props =>
    !props.stackItems &&
    props.verticalPositioning &&
    `align-items: ${transformFlexEndCSSValue(props.verticalPositioning)};`}
  ${({ gap }) => gap && `gap: ${gap}`}
`;

type HorizontalPositioning = 'center' | 'space-around' | 'space-between' | 'end';

type VerticalPositioning = 'center' | 'end';

export interface BoxProps extends IntrinsicProps {
  /**
   * Box padding.
   * @default "0"
   */
  padding?: string;
  /**
   *  Box margin.
   * @default "0"
   */
  margin?: string;
  /**
   * Stacks items in Box on top of each other.
   */
  stackItems?: boolean;
  /**
   * Horizontal positioning of items ("center" | "space-around"| "space-between" | "end").
   */
  horizontalPositioning?: HorizontalPositioning;
  /**
   * Vertical positioning of items ("center" | "end").
   */
  verticalPositioning?: VerticalPositioning;
  /**
   * Gap between elements
   */
  gap?: string;
}

const defaultProps: Pick<BoxProps, 'padding' | 'margin'> = {
  padding: '0',
  margin: '0',
};

export const Box: FC<BoxProps> = props => (
  <BoxElement data-testid="Box" {...props}>
    {props.children}
  </BoxElement>
);

const transformFlexEndCSSValue = (propValue: string) => {
  if (propValue === 'end') {
    return 'flex-end';
  }

  return propValue;
};

Box.defaultProps = defaultProps;
